'use client';

import { c as _c } from "react/compiler-runtime";
import cx from 'classix';
import { format, isEqual, isPast } from 'date-fns';
import { useLocale, useTranslations } from 'next-intl';
import { type DateTimeFormatOptions } from 'use-intl';
import { type ListingDataView } from '@/features/listing/types/listing-types';
import styles from './listing-move-in-date.module.scss';
interface ListingMoveInDateProps {
  moveInDate: Date;
  isListingPerson: boolean;
  view?: ListingDataView;
}
export default function ListingMoveInDate(props) {
  const $ = _c(18);
  const {
    isListingPerson,
    moveInDate,
    view: t0
  } = props;
  const view = t0 === undefined ? "isCard" : t0;
  const translationsCard = useTranslations("listing.card");
  const availableDate = new Date(moveInDate);
  const currentDate = new Date();
  const isToday = isEqual(format(availableDate, "MM/dd/yyyy"), format(currentDate, "MM/dd/yyyy"));
  const isImmediately = isPast(format(availableDate, "MM/dd/yyyy")) && !isToday;
  const locale = useLocale();
  const options = {
    day: "numeric",
    month: "short",
    year: "numeric"
  };
  const formattedDate = new Intl.DateTimeFormat(locale, options).format(availableDate);
  const t1 = styles[`listingMoveInDate__${view}`];
  let t2;
  if ($[0] !== t1) {
    t2 = cx(styles.listingMoveInDate, t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = isListingPerson ? "move-in-date" : "available-date";
  let t4;
  if ($[2] !== t3 || $[3] !== translationsCard) {
    t4 = translationsCard(t3);
    $[2] = t3;
    $[3] = translationsCard;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const t5 = `${t4}${view === "isCard" ? ":" : ""}`;
  let t6;
  if ($[5] !== t5) {
    t6 = <span className={styles.listingMoveInDate_move}>{t5}</span>;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const t7 = view === "isCard" && " ";
  let t8;
  if ($[7] !== formattedDate || $[8] !== isImmediately || $[9] !== translationsCard) {
    t8 = isImmediately ? translationsCard("immediately") : formattedDate;
    $[7] = formattedDate;
    $[8] = isImmediately;
    $[9] = translationsCard;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t8) {
    t9 = <span className={styles.listingMoveInDate_date}>{t8}</span>;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== t2 || $[14] !== t6 || $[15] !== t7 || $[16] !== t9) {
    t10 = <p className={t2}>{t6}{t7}{t9}</p>;
    $[13] = t2;
    $[14] = t6;
    $[15] = t7;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  return t10;
}